<app-loading></app-loading>


@if(hasAccess) {
<main class="main-content">
    <p-toast />
    <app-top-bar></app-top-bar>
    <app-side-bar></app-side-bar>
    <section class="content">
        <div class="container">
            <router-outlet></router-outlet>
        </div>
    </section>
    <!-- <app-footer></app-footer> -->
</main>
} 
@if(!hasAccess && !loading) {
<div class="loading-access">
        <div class="message-container">
            <i class="pi pi-exclamation-triangle" style="font-size: 2.5rem"></i>
            <h1>Acesso Negado</h1>
            <p>Não possuí permissões para aceder a área solicitada.</p>
            <p>Será redirecionado para o login.</p>
            <div class="w-50">
                <p-progressbar [value]="valueSpinner()" />
            </div>
        </div>
</div>

}